var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-checkable cog-input",
      class: [
        { "cog-checkable--allow-other": _vm.allowOther },
        _vm.hasColumns ? _vm.columnClasses : "cog-checkable--inline",
        _vm.readonly ? "is-read-only" : ""
      ]
    },
    [
      _vm.readonly
        ? _c(
            "div",
            {
              class: { "cog-checkable--read-only-images": _vm.hasImageOption }
            },
            [
              !_vm.selectedOptions.length
                ? [_vm._v(" ")]
                : [
                    _vm.columns > 0
                      ? [
                          _vm._l(_vm.selectedOptions, function(item, i) {
                            return [
                              _c(
                                "div",
                                {
                                  key: item.value,
                                  staticClass: "cog-checkable__item",
                                  class: _vm.hasColumns
                                    ? "cog-inner-col__item"
                                    : null,
                                  style: `order: ${_vm.optionOrder[i]}`
                                },
                                [
                                  _vm._t(
                                    "readonly-item",
                                    function() {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              "cog-image-item":
                                                item.image ||
                                                item.svg ||
                                                item.choiceImage
                                            }
                                          },
                                          [
                                            item.svg
                                              ? _c("c-generated-avatar", {
                                                  attrs: { svg: item.svg }
                                                })
                                              : item.image
                                              ? _c("img", {
                                                  staticClass:
                                                    "cog-lookup-image cog-avatar",
                                                  attrs: {
                                                    src: item.image,
                                                    height: "50",
                                                    width: "50"
                                                  }
                                                })
                                              : item.choiceImage
                                              ? _c("div", {
                                                  staticClass:
                                                    "cog-choice-image",
                                                  style: {
                                                    backgroundImage: `url(${item.choiceImage})`
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("breakWords")(
                                                  item.displayValue
                                                )
                                              )
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    { item: item }
                                  )
                                ],
                                2
                              )
                            ]
                          })
                        ]
                      : [
                          _vm._l(_vm.selectedOptions, function(item, index) {
                            return [
                              _vm._v(
                                _vm._s(index && !_vm.hasImageOption ? ", " : "")
                              ),
                              _vm._t(
                                "readonly-item",
                                function() {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        key: item.value,
                                        class: {
                                          "cog-image-item":
                                            item.image ||
                                            item.svg ||
                                            item.choiceImage
                                        }
                                      },
                                      [
                                        item.svg
                                          ? _c("c-generated-avatar", {
                                              attrs: { svg: item.svg }
                                            })
                                          : item.image
                                          ? _c("img", {
                                              staticClass:
                                                "cog-lookup-image cog-avatar",
                                              attrs: {
                                                src: item.image,
                                                height: "50",
                                                width: "50"
                                              }
                                            })
                                          : item.choiceImage
                                          ? _c("div", {
                                              staticClass: "cog-choice-image",
                                              style: {
                                                backgroundImage: `url(${item.choiceImage})`
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("breakWords")(
                                              item.displayValue
                                            )
                                          )
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                { item: item }
                              )
                            ]
                          })
                        ]
                  ]
            ],
            2
          )
        : [
            _c(
              "el-checkbox-group",
              {
                attrs: { role: null, label: null },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.internalValue,
                  callback: function($$v) {
                    _vm.internalValue = $$v
                  },
                  expression: "internalValue"
                }
              },
              [
                _vm._l(_vm.options, function(item, i) {
                  return _c(
                    "el-checkbox",
                    {
                      key: item.value,
                      staticClass: "cog-checkable__item",
                      class: { "cog-inner-col__item": _vm.hasColumns },
                      style: `order: ${_vm.optionOrder[i]}`,
                      attrs: { label: item.value }
                    },
                    [
                      _c(
                        "div",
                        {
                          class: {
                            "cog-image-item":
                              item.image || item.svg || item.choiceImage
                          }
                        },
                        [
                          item.svg
                            ? _c("c-generated-avatar", {
                                attrs: { svg: item.svg }
                              })
                            : item.image
                            ? _c("img", {
                                staticClass: "cog-lookup-image cog-avatar",
                                attrs: {
                                  src: item.image,
                                  height: "50",
                                  width: "50"
                                }
                              })
                            : item.choiceImage
                            ? _c("div", {
                                staticClass: "cog-choice-image",
                                style: {
                                  backgroundImage: `url(${item.choiceImage})`
                                }
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm._f("breakWords")(item.displayValue)) +
                              "\n\t\t\t\t"
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.allowOther
                  ? _c(
                      "el-checkbox",
                      {
                        staticClass: "cog-checkable__allow-other",
                        class: {
                          "is-checked": _vm.otherIsChecked,
                          "cog-inner-col__item": _vm.hasColumns
                        },
                        style: `order: ${_vm.optionOrder[_vm.options.length]}`,
                        attrs: {
                          value: _vm.otherIsChecked,
                          label: _vm.otherValue
                        },
                        on: { change: _vm.handleOtherCheckChange }
                      },
                      [
                        _c("el-input", {
                          ref: "other",
                          attrs: {
                            placeholder: _vm.$resource(
                              "field-choice-other-fill-in"
                            )
                          },
                          on: {
                            focus: _vm.handleOtherInputFocus,
                            blur: _vm.handleOtherInputBlur
                          },
                          model: {
                            value: _vm.otherValue,
                            callback: function($$v) {
                              _vm.otherValue = $$v
                            },
                            expression: "otherValue"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }